/**
 * Namespace for utility functions.
 *
 * @namespace utils
 */
const Utils = {};

/* Use a natural sort order instead of JavaScript's brain dead default sort
 * order. */
Utils.naturalSort = function (a, b) {
  const NUMBER_GROUPS = /(-?\d*\.?\d+)/g;

  const aa = String(a).split(NUMBER_GROUPS),
    bb = String(b).split(NUMBER_GROUPS),
    min = Math.min(aa.length, bb.length);

  for (let i = 0; i < min; i++) {
    const x = parseFloat(aa[i]) || aa[i].toLowerCase(),
      y = parseFloat(bb[i]) || bb[i].toLowerCase();
    if (x < y) {
      return -1;
    } else if (x > y) {
      return 1;
    }
  }
  return 0;
};

/* Round a Number to 2 decimal places using exponential notation */
/* This is to work around floating point weirdness in javascript */
Utils.roundFloat = function (num, decimals) {
  const expNum = Number(`${num}e${decimals}`);
  const expDec = `e-${decimals}`;
  return Number(Math.round(expNum) + expDec);
};

/* Convert the nav property to a string for display. */
Utils.navToTitle = function (nav) {
  let rval;
  if (typeof nav === "string") {
    rval = nav
      .split(" ")
      .map((elem) => elem.charAt(0).toUpperCase() + elem.substr(1));
    rval = rval.join(" ").trim();
  } else {
    rval = " ";
  }
  return rval;
};

/**
 * Creates an array of values starting at beginVal up to but not including endVal
 * Similiar to Ruby's [1..N], only works for whole numbers
 */
Utils.range = function (beginVal, endVal) {
  return Array(endVal - beginVal)
    .fill(0)
    .map((v, i) => i + beginVal);
};

/**
 * Creates an array of values starting at beginVal through endVal
 * Similiar to Ruby's [1...N], only works for whole numbers
 */
Utils.rangeInclude = function (beginVal, endVal) {
  if (!Number.isInteger(beginVal)) {
    beginVal = Number(beginVal);
  }
  if (!Number.isInteger(endVal)) {
    endVal = Number(endVal);
  }
  return Array(endVal + 1 - beginVal)
    .fill(0)
    .map((v, i) => i + beginVal);
};

Utils.gridColumnDescription = function (col) {
  // YM  Youth Deer Hunting Season Male Deer Harvest
  // YF  Youth Deer Hunting Season Female Deer Harvest
  // YT  <YM+YF> Youth Deer Hunting Season Total Deer Harvest
  // MM  Muzzleloading Deer Hunting Season Male Deer Harvest
  // MF  Muzzleloading Deer Hunting Season Female Harvest
  // MT  <MM+MF> Muzzleloading Deer Hunting Season Total Harvest
  // FM  Firearm Deer Hunting Season Male Deer Harvest
  // FF  Firearm Deer Hunting Season Female Harvest
  // FT  <FM+FF> Firearm Deer Hunting Season Total Harvest
  // AM  Archery Deer Hunting Season Male Deer Harvest
  // AF  Archery Deer Hunting Season Female Harvest
  // AT  <AM+AF> Archery Deer Hunting Season Total Harvest
  // LM  Late Deer Hunting Season Male Deer Harvest
  // LF  Late Deer Hunting Season Female Harvest
  // LT  <LM+LF> Late Deer Hunting Season Total Harvest
  // TF  <YF+MF+FF+AF+LF> Total Female Harvest
  // TM  <YM+MM+FM+AM+LF> Total Male Harvest
  // TT  <TF+TM> Total Harvest
  // RATIO <TF/TM> Sex Ratio of Harvest
  switch (col) {
    case "YM":
      return "Youth Deer Hunting Season Male Deer Harvest";
    case "YF":
      return "Youth Deer Hunting Season Female Deer Harvest";
    case "YT":
      return "Youth Deer Hunting Season Total Deer Harvest";

    case "MM":
      return "Muzzleloading Deer Hunting Season Male Deer Harvest";
    case "MF":
      return "Muzzleloading Deer Hunting Season Female Deer Harvest";
    case "MT":
      return "Muzzleloading Deer Hunting Season Total Deer Harvest";

    case "FM":
      return "Firearm Deer Hunting Season Male Deer Harvest";
    case "FF":
      return "Firearm Deer Hunting Season Female Deer Harvest";
    case "FT":
      return "Firearm Deer Hunting Season Total Deer Harvest";

    case "AM":
      return "Archery Deer Hunting Season Male Deer Harvest";
    case "AF":
      return "Archery Deer Hunting Season Female Deer Harvest";
    case "AT":
      return "Archery Deer Hunting Season Total Deer Harvest";

    case "LM":
      return "Late Deer Hunting Season Male Deer Harvest";
    case "LF":
      return "Late Deer Hunting Season Female Deer Harvest";
    case "LT":
      return "Late Deer Hunting Season Total Deer Harvest";

    case "TF":
      return "Total Female Harvest";
    case "TM":
      return "Total Male Harvest";

    case "TT":
      return "Total Harvest";

    case "RATIO":
      return "Sex Ratio of Harvest (TF/TM)";

    default:
      return "Unknown column";
  }
};

module.exports = Utils;
